package com.wintermar.inspection.feature.presentation.inspection.landing.widget.inspection_preview

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.Dp
import com.wintermar.inspection.core.ui.component.TextBodyLarge
import com.wintermar.inspection.core.ui.theme.AppDimension
import com.wintermar.inspection.core.ui.theme.LocalAppTheme
import com.wintermar.inspection.feature.domain.model.inspection.InspectionModel
import com.wintermar.inspection.feature.domain.model.template.TemplateOptionModel
import com.wintermar.inspection.feature.presentation.inspection.widget.AnswerSummaryView
import com.wintermar.inspection.feature.presentation.inspection.widget.InspectionInfo
import com.wintermar.inspection.feature.util.inspection_status.InspectionStatusView
import inspection.composeapp.generated.resources.Res
import inspection.composeapp.generated.resources.flagged_items
import org.jetbrains.compose.resources.stringResource

@Composable
fun InspectionPreview(
    data: InspectionModel,
    verticalPadding: Dp,
    templateOptions: List<TemplateOptionModel>,
    dimension: AppDimension = LocalAppTheme.current.dimension,
) {
    var flaggedItems by remember(data) {
        mutableStateOf(data.template.getFlaggedAnswer())
    }

    LazyColumn(
        modifier = Modifier
            .fillMaxWidth()
            .padding(
                horizontal = dimension.spacing.space4
            )
    ) {
        item {
            Spacer(modifier = Modifier.height(dimension.spacing.space2 + verticalPadding))
            Row(
                modifier = Modifier.fillMaxWidth(),
                horizontalArrangement = Arrangement.spacedBy(
                    space = dimension.spacing.space4
                )
            ) {
                TextBodyLarge(
                    text = data.templateName,
                    bold = true,
                    modifier = Modifier.weight(1f)
                )
                InspectionStatusView(status = data.status, asBadge = true)
            }

            Spacer(modifier = Modifier.height(dimension.spacing.space3))

            InspectionInfo(
                locationName = data.template.getLocation(),
                lastUpdated = data.lastUpdated,
                conducted = data.conducted,
                vesselName = data.vesselName,
                totalDisplayAnswer = "${data.totalAnswer}/${data.totalQuestion}",
            )
        }

        if (flaggedItems.isNotEmpty()) {
            item {
                AnswerSummaryView(
                    title = stringResource(Res.string.flagged_items),
                    items = flaggedItems,
                    templateOptions = templateOptions
                )
                Spacer(modifier = Modifier.height(dimension.spacing.space3))
            }
        }
    }
}
